/**
 * Novastar — the original Bubot Worlds look. Cyan-on-deep-space sci-fi with
 * glow + CRT scanlines. This is the default theme; its cssVars mirror the
 * :root defaults in index.css.
 */
export const novastar = {
  id: 'novastar',
  name: 'Novastar',
  assignable: true,
  mantine: {
    primaryColor: 'cyan',
    fontFamily: 'Rajdhani, sans-serif',
    headings: { fontFamily: 'Orbitron, sans-serif' },
  },
  cssVars: {
    '--bw-bg': 'radial-gradient(ellipse at 50% 20%, #0d1f3c 0%, #060e1a 60%, #020408 100%)',
    '--bw-body-color': '#e0e8f0',
    '--bw-panel-bg': 'rgba(10, 22, 40, 0.92)',
    '--bw-panel-border': 'rgba(0, 255, 255, 0.1)',
    '--bw-accent': 'rgba(0, 255, 255, 1)',
    '--bw-glow-color': 'rgba(0, 255, 255, 0.3)',
    '--bw-glow-text-color': 'rgba(0, 255, 255, 0.5)',
    '--bw-body-font': "'Rajdhani', sans-serif",
    '--bw-heading-font': "'Orbitron', sans-serif",
    '--bw-heading-letter-spacing': '0.05em',
    '--bw-content-base': '1.125rem',
  },
}
